module.exports = __webpack_public_path__ + "static/media/BERJALGUI_MENU-normal.ce229a53.png";